import React from "react";
import Header from "../../common/Header.js";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../../utlis/user/routes.utlis";
import blogImageone from "../../../assets/images/Blog-banner-1.jpg";
import blogImagetwo from "../../../assets/images/Blog-banner-2.jpg";
import blogImagethree from "../../../assets/images/Care Exchange Blog Banner 1.jpg";
import "../../../assets/user/css/home.css";

const Blog = () => {
  return (
    <>
      <Header></Header>
      <div className="care-provider-blog-section blog-banner">
        <div className="container">
          <div className="row g-3">
            <div className="col-md-4">
              <div className="care-blog-card">
                <div className="blog-media">
                  <img src={blogImagethree} alt="Care Exchange Blog Banner" />
                </div>
                <div className="blog-content">
                  <h2>
                    Your Essential Guide to Picking Professional Care Services
                    for Seniors
                  </h2>
                  <p>
                    When you start to find professional care services for
                    seniors, you realize how overwhelming it can be. So many
                    options promise trust and compassion, yet few truly deliver
                    it. But, you know how much the right choice means. It’s not
                    just about getting someone to help; it’s about bringing
                    peace of mind, companionship, and genuine care into your
                    loved one’s everyday life. Here’s what you should focus on
                    before making that all-important decision.
                  </p>
                  <Link className="btn-gr" to={routes.blogDetail1}>
                    Read More
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="care-blog-card">
                <div className="blog-media">
                  <img src={blogImagetwo} alt="Care Exchange Blog Banner" />
                </div>
                <div className="blog-content">
                  <h2>
                    Transforming Homecare: The Essential Role of Professional
                    Caregivers
                  </h2>
                  <p>
                    At Care Exchange, we understand that care is more than just
                    assistance- it’s trust, compassion, and professional support
                    that helps people live with dignity and independence in the
                    comfort of their own homes. Whether it’s helping seniors
                    with daily tasks, assisting individuals recovering from
                    illness, or offering companionship and emotional comfort,
                    homecare professionals play a crucial role in enhancing
                    quality of life.
                  </p>
                  <Link className="btn-gr" to={routes.blogDetail2}>
                    Read More
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="care-blog-card">
                <div className="blog-media">
                  <img src={blogImageone} alt="Care Exchange Blog Banner" />
                </div>
                <div className="blog-content">
                  <h2>
                    How to Find Senior Home Care Jobs & Thrive in Professional
                    Care
                  </h2>
                  <p>
                    At Care-Exchange, we believe that the heart of excellent
                    elder-care lies in the passion of the people who deliver it.
                    If you’re someone who cares deeply, who’s looking not just
                    for a job but for purpose, then exploring senior homecare
                    jobs is the right move. In this blog, we’ll walk you through
                    why senior homecare jobs are so impactful, what it takes to
                    succeed, and how our platform lets you find senior home care
                    jobs easily. We’ll also show how you can connect with real
                    opportunities to find professional roles where your skills,
                    your compassion, and your dedication matter.
                  </p>
                  <Link className="btn-gr" to={routes.blogDetail3}>
                    Read More
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="care-provider-footer">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="care-provider-copyright">
                <p>&copy; 2025 Care-Exchange.com. All rights reserved.</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="care-provider-copyright text-end">
                <Link className="" to={routes.about}>
                  About Us
                </Link>{" "}
                &nbsp; | &nbsp;
                <Link className="" to={routes.contact}>
                  Contact Us
                </Link>{" "}
                &nbsp; | &nbsp;
                <Link className="" to={routes.term}>
                  Terms and Conditions
                </Link>{" "}
                &nbsp; | &nbsp;
                <Link className="" to={routes.privacy}>
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blog;
